import React from "react";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold uppercase tracking-widest text-[#5aa83a]">
            Kind words
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#123c74]">
            Families who feel the difference
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="relative bg-[#f6f9f3] rounded-2xl p-8 border border-slate-50 hover:shadow-lg transition-shadow duration-300"
            >
              <Quote className="h-10 w-10 text-[#5aa83a]/25 absolute top-6 right-6" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-[#f5b301]" fill="#f5b301" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed relative z-10">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 flex items-center gap-3">
                <img
                  src={t.image}
                  alt={t.name}
                  className="h-12 w-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-bold text-[#123c74]">{t.name}</p>
                  <p className="text-sm text-slate-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
